<template>
  <el-container class="form-runtime" :style="{overflow: hasDiscussOrLogPane ? 'hidden' : 'auto'}">
    <el-main ref="formMain" :class="{'form-runtime-main-padding': showDiscussOrLogTabPane}">
      <!-- 分组导航栏-->
      <div v-if="showGroupNav" class="form-group-nav">
        <el-tabs tab-position="left" @tab-click="navToGroup" value="''">
          <el-tab-pane v-for="(item,index) in groupComponent" :key="index" :label="item.name" @click.native="test">
            <span slot="label" :title="item.name">{{item.name && item.name.length > 16 ? item.name.slice(0,15)+'...' : item.name}}</span>
          </el-tab-pane>
        </el-tabs>
      </div>
      <rc-form
        ref="form"
        v-if="definition.form"
        :value="dataService.data"
        :component="definition.form"
        :disable="buttonLook"
        :showGroupNav="showGroupNav"
        :dialogWidth="dialogWidth"/>
    </el-main>
    <!-- 日志与讨论控件-->
    <discuss-log-component ref="disucssLogComponent"
                           v-if="hasDiscussOrLogPane"
                           :defineId="definition.id"
                           :form="definition.form"
                           :dataId="dataService.data.id"
                           :dataState="dataService.data.dataState"
                           @discuss-preview-image="discussPreviewImage"
                           @showDiscussOrLogTabPane="showTabPane"></discuss-log-component>
    <!-- 日志与讨论控件的图片预览 -->
    <PicturePreview ref="picturePreview" @closePreview="closePreview" :coverPicList="currentPreviewImgUrl"  v-if="currentPreviewImgUrl.length > 0" :src="currentPreviewImgUrlSrc"></PicturePreview>
    <el-footer :class="['form-footer', {'form-runtime-footer-padding': showDiscussOrLogTabPane}]">
      <!-- 因为视图先渲染，数据后加载，不加 v-if 会导致页面先报错再渲染 -->
      <div class="continue-create" v-if="showHint">
        <el-checkbox v-model="continueCreate">提交后继续创建下一条</el-checkbox>
      </div>
      <div class="buttons runtime-buttons" v-if="!buttonLook">
        <el-button ref="formButtons" :tabindex="10000 + index" v-for="(button,index) in definition.buttons" :key="button.id" :type="button.type==='comfirm'?'primary':''" :disabled="button.disabled" :title="button.title"
                   @click="click(button,index)" v-if="getShowButton(button)">
          <i class="el-icon-loading" v-show="'comfirm,custom'.includes(button.type)&&loading&&activeButton===index"></i>
          {{button.name}}
        </el-button>
      </div>
    </el-footer>
    <custom-dialog :data="customDialog"></custom-dialog>
    <dialog-form-runtime :formRuntimeDialog="rcTableFormRuntimeDialog"></dialog-form-runtime>
  </el-container>
</template>

<script>
import sdk from 'redcatSdk'
import {calculationMixin, interactionMixin} from './components/mixins'
import RcForm from './components/rc-form.vue'
import Definition from '@/store/form/definition'
import DataService from '../../../store/form-runtime/dataService.js'
import Schema from '@/store/form/schema.js'
import CodeService, {EventBus} from '@/store/form-runtime/codeService'
import {UUID} from '@/plugins/common'
import {AsyncRequest} from '@/components/form/runtime/components/utils/AjaxRequestLimit.js'
import DiscussLogComponent from './components/discussLogComponents/discuss-log-component'
import discussLogMixin from './components/discussLogComponents/discussLogMixin'
import PicturePreview from './components/picture-preview-swiper.vue'
import {rcTableEditViaForm} from '@/components/shared/runtimeMixins'

let dataService = new DataService()

export default {
  name: 'FormRuntime',
  props: ['id', 'depId', 'isDialog', 'dialogWidth', 'dialogDisabled', 'dialogDataId', 'formValidates', 'interactions', 'tableEdit', 'disableClick', 'dialogTitle', 'compareField', 'passFieldList', 'openType'],
  mixins: [calculationMixin, interactionMixin, discussLogMixin, rcTableEditViaForm],
  provide () {
    return {
      dataService,
      eventBus: this.eventBus,
      initState: {},
      initCount: this.initCount,
      // 直接使用 redcatApp导致值不更新。不想再在一层所以用方法
      redcatApp: this.getRedcatApp,
      formArgs: {formType: '新建'},
      formVm: this
    }
  },
  data () {
    return {
      eventBus: new EventBus(),
      initStateObj: {state: false, showGroupNav: false},
      buttonLook: this.$route.query.disabled || this.dialogDisabled,
      dataId: this.$route.query.dataId || this.depId || this.dialogDataId,
      definition: {},
      dataService,
      customDialog: {
        dialog: {
          visible: false
        }
      },
      loading: false,
      activeButton: 0,
      initCount: {value: 0},
      isShow: false,
      continueCreate: false,
      redcatApp: {},
      showGroupNav: false,
      oldGroupComponent: null,
      hasDiscussOrLogPane: false,
      showDiscussOrLogTabPane: false
    }
  },
  components: {
    RcForm,
    DiscussLogComponent,
    PicturePreview,
    customDialog: () => {
      return Promise.resolve(sdk.components.CustomDialog)
    },
    DialogFormRuntime: () => import('@/components/shared/dialog-form-runtime.vue')
  },
  created () {
    this.initCreate()
  },
  beforeDestroy () {
    // 需要删除加载进来的scrip标签
    let script = document.getElementById(this.definition.jsPath)
    script && document.body.removeChild(script)
  },
  mounted () {
    this._provided.formArgs.formType = this.dialogTitle || '新建'
    this.eventBus.$emit('form.afterInit')
  },
  methods: {
    async initCreate () {
      dataService = new DataService()
      this._provided.dataService = this.dataService
      this._provided.initState = this.initStateObj
      /*
             * 运行页的生命周期
             *
             * 加载表单
             * 数据模型（用于控件绑定）
             * 渲染控件（vue 执行）
             * 控件初始化（设置默认值，加载选项）
             * 加载数据
             * 加载系统默认值
             * 注册事件
             *
             * 执行校验
             * 构建数据
             * 控件初始化（设置默认值，加载选项）
             * 提交数据
             */
      await this.loadForm().then(async () => {
        this.$refs.form && this.$refs.form.sortComponent()
        if (this.tableEdit && this.tableEdit.switch) {
          await this.setDataService(this.tableEdit.data)
        } else {
          if (this.dataId) {
            await this.loadData(this.dataId)
          } else {
            // 新建的表单需要判断是否有缓存数据
            // 没有缓存数据才需要构建数据模型
            await this.loadHoldData(this.definition.id).then(async haveHoldData => {
              if (!haveHoldData) {
                await this.buildData()
                // 66th 新建透传 数据联动赋值
                if (this.openType === 'transmission-create') {
                  this.passFieldList.forEach(item => {
                    if (item.form && item.report) {
                      this.dataService.data[item.form] = item.value
                    }
                  })
                }
              }
            })
          }
        }
        // 是否展示讨论或日志侧边弹框
        this.getDisscussOrLogDrawer()
        this._provided.initState.type = 'form'
        const formService = {
          openCustomDialog: (data) => {
            this.customDialog.dialog = data
          }
        }
        const codeService = new CodeService({ eventBus: this.eventBus, form: { define: this.definition, dataService: this.dataService }, formService, el: this })
        codeService.load()
        await this.eventBus.$emit('form.beforeInit')
        this.$nextTick(() => {
          this.init()
        })
      })
    },
    loadForm () {
      return new Promise(resolve => {
        this.$axios.get('/form-api/defines/' + this.id)
          .then(res => {
            this.definition = new Definition(res.data)
            this.dataService.schema = new Schema()
            this.dataService.schema.load(res.data.form.schema)
            // 是否展示分组导航
            this.getGroupNav()
            // 获取该表单的归档信息
            try {
              this.getArchivedColumns(res.data.form.form.archive.tableId)
            } catch (e) {
              console.warn('归档表加载失败')
            }
            if (this.definition.jsPath && this.definition.form.properties && this.definition.form.properties.functionsName) {
              let exts = document.createElement('script')
              exts.src = `${sessionStorage.getItem('ossDownloadUrl')}/${this.definition.jsPath}`
              exts.id = this.definition.jsPath
              document.body.appendChild(exts)
              exts.onload = () => {
                let redcatApp = window.redcatApp[this.id]
                if (redcatApp) {
                  this.redcatApp = redcatApp
                  // 调用脚本的load方法加载定制方法
                  // 注意：因为使用call改变了当前this指向，所以在load方法中不能调用执行脚本中的其他方法
                  this.redcatApp['load'] && this.redcatApp['load'].call(this, this)
                  // 扩展当前对象属性
                  this.bindApi(this.redcatApp)
                  this.$nextTick(() => resolve())
                } else {
                  resolve()
                }
              }
              exts.onerror = () => resolve()
            } else {
              resolve()
            }
          })
      })
    },
    loadData (dataId) {
      let params = {dataId}
      // 报表透传
      if (this.compareField && this.compareField !== 'Id') {
        params.dataId = this.compareField
      }
      return this.$axios.get(`/form-api/runtime/${this.definition.form.id}/loadData`, { params: params })
        .then(res => {
          let data = this.dataService.buildModel(this.definition.form.archive.tableId, res.data)
          // 报表透传
          if (this.compareField) {
            this.passFieldList.forEach(item => {
              if (item.form && item.report) {
                data[item.form] = item.value
              }
            })
          }
          this.dataService.data = data
          this.formValue.newValue = this.dataService.data
          this.formValue.oldValue = this.$_.cloneDeep(this.dataService.data)
        })
    },
    buildData () {
      this.dataService.data = this.dataService.buildModel(this.definition.form.archive.tableId)
    },
    init () {
      return this.initComponents()
    },
    async initComponents () {
      if (this.$refs.form) {
        await this.$refs.form.init()
      }
      this.initStateObj.state = true
      this.initInteraction()
      this.initButton()
      // 子组件聚焦第一个可用控件(只在表单新建时可用)
      if (this.dataService.data && this.dataService.data.dataState === 'create') {
        this.$refs.form.firstInputFocus()
      }
      this.$emit('afterInit')
    },
    initButton () {
      this.eventBus.$emit('form.initButton')
    },
    validate () {
      return this.$refs.form.validate()
    },
    click (button, index) {
      if (this.disableClick) {
        return false
      }
      // 暂存除了操作提醒直接走暂存接口，其他的啥也不干
      if (button.type === 'hold') {
        this.loading = true
        this.operationTip(button).then(() => this.holdForm()).catch(() => { this.loading = false })
      } else {
        this.activeButton = index
        // 禁用按钮
        this.buttonState(true)
        // 如果是取消按钮就直接关闭
        if (button.type === 'cancel') {
          this.operationTip(button)
            .then(() => {
              if (this.isDialog) {
                this.$emit('closeDialog', 'comfirm')
                if (this.tableEdit && this.tableEdit.switch) {
                  let currentTableListener = this.redcatEventBus.rcTableListenerArray.find(item => item.id === this.tableEdit.componentId)
                  currentTableListener && currentTableListener.redcatEventBus.$emit('tableEditCancel')
                }
              } else {
                this.cancel()
                this.buttonState(false)
              }
            })
            .catch(() => {
              this.buttonState(false)
            })
        } else {
          this.loading = true
          this.buttonEvent(button).then(async () => {
            this.$emit('buttonClickBefore', button.type)
            // 表单提交成功之后，需要删除暂存的数据
            // 只有新建的时候才需要删除
            this.dataService.data.dataState === 'create' && this.$axios.delete(`/form-api/runtime/tempSave/${this.definition.id}`)
            if (this.isDialog) {
              // 根据 提交后继续创建下一条 的值，判断是否关闭弹框
              if (this.definition.form.properties.continueCreate && this.dataService.data.dataState !== 'update' && this.continueCreate) {
                this.$emit('goSearch')
                this.$message({message: '保存成功！', type: 'success'})
                this.initCreate()
                this.initCount.value++
              } else {
                await this.executeFunctions(button, 'afterSubmit')
                this.$emit('closeDialog', button.type)
              }
            } else {
              // 表单多标签页点击保存清空数据
              // this.$message({message: '保存成功！', type: 'success'})
              this.cancel()
              await this.executeFunctions(button, 'afterSubmit')
            }
            this.loading = false
            // 解除按钮禁止
            this.buttonState(false)
            this.$emit('buttonClickAfter', button.type)
          }).catch(() => {
            this.loading = false
            this.buttonState(false)
          })
        }
      }
    },
    buttonState (state) {
      this.$refs.formButtons.forEach(m => {
        m.$el.disabled = state
      })
    },
    findJuheColumns (text, result) {
      let juhefunc = ['sum', 'max', 'average', 'count', 'min', 'group_concat', 'sumif', 'averageif', 'averageif', 'simple', 'large', 'small', 'median']
      let func = 'wu'
      for (let i = 0; i < juhefunc.length; i++) {
        if (text.toLowerCase().indexOf(juhefunc[i]) !== -1) {
          func = juhefunc[i]
          break
        }
      }
      let postion = text.toLowerCase().indexOf(func)
      if (postion === -1) {
        return result
      } else {
        let char = ''
        const stacks = []
        let newtext = text.slice(postion)
        let index = 0
        for (let i = 0; i < newtext.length; i++) {
          char = newtext[i]
          if (char === ')') {
            stacks.push(char)
            let str = stacks.join('')
            if (str.split('(').length === str.split(')').length) {
              index = i
              break
            }
          } else {
            stacks.push(char)
          }
        }

        result.push(stacks.join(''))
        return this.findJuheColumns(text.slice(postion + index), result)
      }
    },
    // 操作校验
    async formValidate (formValidates) {
      if (formValidates) {
        await Promise.all(formValidates.map(el => {
          return new Promise(async (resolve, reject) => {
            let valueArr = this.getColumnIds(el.expression)
            // 找到被聚合函数包裹的字段
            let JuheColumns = this.findJuheColumns(el.expression, [])
            valueArr.forEach(m => {
              m.juhe = false
              if (JuheColumns.some(n => n.includes(m.columnId))) {
                m.juhe = true
              }
            })
            // 是校验子表格数据
            let isChild = valueArr.some(a => a.relationId)
            if (isChild) {
              let length = 1

              let hasNotJuheColumn = valueArr.some(a => a.relationId && this.dataService.data[a.relationId] && !a.juhe)
              // 有一个表格内的字段不是聚合就需要遍历 拿到表格行数
              if (hasNotJuheColumn) {
                // 拿到表格行数
                valueArr.map(m => {
                  if (m.relationId) {
                    length = this.dataService.data[m.relationId].length
                  }
                })
              }
              el.expressionResult = []
              for (let i = 0; i < length; i++) {
                let obj1 = {}
                valueArr.map(async m => {
                  if (m.relationId && m.juhe) {
                    let prame = []
                    this.dataService.data[m.relationId].forEach(el => {
                      if (el[m.columnId] !== '' && typeof (m.columnId) !== 'undefined' && el[m.columnId] !== null) {
                        prame.push(el[m.columnId])
                      }
                    })
                    if (prame.length > 0) {
                      obj1[m.columnId] = prame
                    }
                  } else if (m.relationId && !m.juhe) {
                    let o = this.dataService.data[m.relationId][i]
                    if (o[m.columnId] !== '' && typeof (m.columnId) !== 'undefined' && o[m.columnId] !== null) {
                      obj1[m.columnId] = o[m.columnId]
                    }
                  } else {
                    obj1[m.columnId] = this.dataService.data[m.columnId]
                  }
                })
                await this.$axios.post('/form-api/runtime/calc', {'formula': el.expression, 'variables': obj1})
                  .then(res => {
                    el.expressionResult.push(res.data)
                  })
              }
              resolve()
            } else {
              let obj = {}
              valueArr.forEach(m => {
                if (m.relationId) {
                  let prame = []
                  this.dataService.data[m.relationId].forEach(el => {
                    if (el[m.columnId] !== '' && typeof (m.columnId) !== 'undefined' && el[m.columnId] !== null) {
                      prame.push(el[m.columnId])
                    }
                  })
                  if (prame.length > 0) {
                    obj[m.columnId] = prame
                  }
                } else {
                  obj[m.columnId] = this.dataService.data[m.columnId]
                }
              })
              this.$axios.post('/form-api/runtime/calc', {'formula': el.expression, 'variables': obj})
                .then(res => {
                  el.expressionResult = [res.data]
                  resolve()
                })
            }
          })
        }))
      } else {
        return Promise.resolve()
      }
    },
    async formValidateTip (formValidates) {
      if (formValidates) {
        for (var i = 0; i < formValidates.length; i++) {
          for (let j = 0; j < formValidates[i].expressionResult.length; j++) {
            await this.singleFormValidate(formValidates[i], formValidates[i].expressionResult[j])
          }
        }
      } else {
        return Promise.resolve()
      }
    },
    singleFormValidate (m, expressionResult) {
      return new Promise((resolve, reject) => {
        if (expressionResult) {
          switch (m.promptType) {
            case 'withoutExecute':
              this.withoutExecuteDialog(m, () => {
                reject(new Error('条件不满足'))
              })
              break
            case 'isExecute':
              this.isExecuteDialog(m, (data) => {
                if (!data) {
                  reject(new Error('条件不满足'))
                } else {
                  resolve()
                }
              })
              break
            case 'withExecute':
              this.withExecuteDialog(m, () => resolve())
              break
            default:
              reject(new Error('未知的错误'))
          }
        } else {
          resolve()
        }
      })
    },
    // 提示且不执行弹窗
    withoutExecuteDialog (operationVilidate, callback) {
      return new Promise((resolve) => {
        this.$message({
          message: operationVilidate.tip,
          center: true,
          duration: 3000,
          customClass: 'without-execute-dialog'
        })
        resolve()
      }).then(() => {
        callback()
      })
    },
    isExecuteDialog (operationVilidate, callback) {
      this.$confirm('', operationVilidate.tip, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'publishMessageBox',
        center: true
      }).then(() => {
        let data = true
        callback(data)
      }).catch(() => {
        let data = false
        callback(data)
      })
    },
    // 提示且执行弹窗
    withExecuteDialog (operationVilidate, callback) {
      this.$alert(operationVilidate.tip, '', {
        confirmButtonText: '确定',
        center: true,
        callback: action => {
          callback()
        }
      })
    },
    // 操作提醒弹窗
    operationTip (button) {
      return new Promise((resolve, reject) => {
        if (button.tipsEnable === true) {
          this.$confirm('', button.tip, {
            confirmButtonText: '是',
            cancelButtonText: '否',
            customClass: 'deleMessageBox',
            center: true
          }).then(() => {
            resolve()
          }).catch(() => {
            reject(new Error('用户选择不提交'))
          })
        } else {
          resolve()
        }
      })
    },
    // 按钮操作事件-确定,取消,自定义
    buttonEvent (button) {
      return new Promise(async (resolve, reject) => {
        if (button.type === 'comfirm') {
          // 先校验所有计算请求是否都执行完了,否则等待
          AsyncRequest.validRequest()
            .then(() => this.submit(button))
            .then(() => {
              resolve()
            }).catch(() => {
              reject(new Error('表单提交失败'))
            })
        } else if (button.type === 'custom') {
          try {
            await this.eventBus.$emit('form.beforeValidate', {button, el: this, asyncRequest: AsyncRequest})
          } catch (e) {
            this.focusErrorInput()
            // 直接 reject 还会执行下面的submit方法
            return reject(e)
          }
          this.submit(button, 'custom').then(() => {
            resolve()
          }).catch(() => {
            reject(new Error('表单提交失败'))
          })
        }
      })
    },
    beforeSubmit (params) {
      return this.eventBus.$emit('form.beforeSubmit', params)
    },
    afterSubmit (button) {
      this.eventBus.$emit('form.afterSubmit', button)
    },
    async submitLog () {
      let data = {
        dataId: this.dataService.data.id,
        defineId: this.definition.id,
        formId: this.definition.form.id,
        content: ''
      }
      if (this.dataService.data && this.dataService.data.dataState === 'create') {
        data.content = `创建`
      } else {
        data.content = await this.getDiffInNewValue()
      }
      if (!data.content) {
        return Promise.resolve()
      }
      return this.$axios.post('/form-api/discuss/log', data)
    },

    submit (button, type) {
      return new Promise((resolve, reject) => {
        this.$nextTick(() => {
          this.validate()
            .then(() => {
              // 处理数据, 将表格中的空行去去掉
              this.dataService.buildSubmitData(this.definition.form)
              this.loading = true
              return this.formValidate(this.formValidates)
            })
            .then(() => this.formValidateTip(this.formValidates))
            .then(() => this.handleInteraction(this.interactions))
            .then(() => this.operationTip(button))
            .then(async () => {
              let interactionIds = []
              this.interactions && this.interactions.forEach(n => {
                if (n.expressionResult) { interactionIds.push(n.id) }
              })
              interactionIds = interactionIds.join(',')
              // 如果 tableEdit 的值 为true，则代表该表单为表格控件所引用，所以不需要走保存接口
              if (this.tableEdit && this.tableEdit.switch) {
                // 记住这里只有表单嵌套表单中的子表单也就是第二个表单才会走，所以这里的this要访问到混入进来的数据应该放在 rcTableFormRuntimeDialog 中
                let currentTableListener = this.redcatEventBus.rcTableListenerArray.find(item => item.id === this.tableEdit.componentId)
                currentTableListener && await currentTableListener.redcatEventBus.$emit('tableEditSubmit', { ...this.dataService.data })
              } else {
                // 取消按钮没有js事件
                if (button.type !== 'cancel') {
                  // 找到提交前需要执行的事件
                  try {
                    await this.executeFunctions(button, 'beforeSubmit')
                  } catch (e) {
                    throw new Error(e)
                  }
                }
                if (type === 'custom') {
                  return this.beforeSubmit({button, el: this})
                } else {
                  this.dataService.data = { ...this.dataService.data, interactionIds }
                  return this.$axios.post(`/form-api/runtime/${this.definition.form.id}/saveData`, this.dataService.data)
                }
              }
            })
            .then(() => this.afterSubmit(button))
            .then(() => {
              // 没开启日志，或者是表单编辑引用了表单，直接通过。否则提交日志
              if (!this.definition.form.properties.enableLog || (this.tableEdit && this.tableEdit.switch)) {
                return resolve()
              }
              return this.submitLog()
            })
            .then(() => {
              resolve()
            })
            .catch(() => {
              this.focusErrorInput()
              reject(new Error('表单提交失败'))
            })
        })
      })
    },
    async handleInteraction (interactions) {
      if (interactions) {
        await Promise.all(interactions.map(m => {
          return new Promise((resolve, reject) => {
            if (m.expression) {
              let valueArr = this.getColumnIds(m.expression)
              let obj = {}
              valueArr.forEach(n => {
                // 带表格的情况,去表格的值
                // todo 不过有问题，因为表格4行数据的columnid相同，会存值的时候会覆盖
                if (n.relationId) {
                  this.dataService.data[n.relationId].forEach(m => {
                    obj[n.columnId] = m[n.columnId]
                  })
                } else {
                  obj[n.columnId] = this.dataService.data[n.columnId]
                }
              })
              this.$axios.post('/form-api/runtime/calc', {'formula': m.expression, 'variables': obj})
                .then(res => {
                  m.expressionResult = res.data
                  resolve()
                })
            } else {
              m.expressionResult = true
              resolve()
            }
          })
        }))
      } else {
        return Promise.resolve()
      }
    },
    buildSubmitData () {
      let data = this.dataService.data
      Object.keys(data).forEach(key => {
        // 如果值是数组类型的, 说明是一个表格或者其他一对多的东西
        if (data[key] instanceof Array) {
          // 临时变量, 下面会使用到
          let tempData = data[key][0]
          // 过滤出数组中所有值都是空的东西
          data[key] = data[key].filter(m => {
            let flag = false
            for (let index in m) {
              // fixme: 这个地方为了方便直接只判断了 UUID 的值是否为空, 以后如果有其他的情况, 请注意修复
              if (index.length > 32 && m[index] !== '') {
                flag = true
                break
              }
            }
            return flag
          })
          if (!data[key] || data[key].length === 0) {
            // 判断, 假如表格中没有填写任何东西, 但是表格中的控件存在必填属性, 则在表格中增加一个一类数据, 给表单校验使用, 赋值内容为上面克隆出来的临时变量
            let table = this.definition.form.find(m => m.archive.relationId === key) || this.definition.form.find(m => m.archive.tableId === key)
            if (table && table.children) {
              let children = table.children
              for (let index in children) {
                if (children[index].properties.required) {
                  break
                }
              }
              table.children.forEach(children => {
                if (children.properties.required) {
                  data[key].push(tempData)
                }
              })
            } else {
              throw new Error('表单错误')
            }
          }
        }
      })
    },
    cancel () {
      // this.initCreate()
      // this.initCount.value++
      this.beforeCancel()
        .then(() => this.$router.go(-1))
    },
    setDataService (data) {
      this.dataService.data = this.dataService.buildModel(this.definition.form.archive.tableId, {...data})
    },
    // 给当前的redcatApp对象绑定
    bindApi (redcatApp) {
      redcatApp.$el = this
      redcatApp.$UUID = UUID
    },
    getRedcatApp () {
      return this.redcatApp
    },
    /*
    * 执行页面js的方法
    * @param type {string} 需要执行的方法类型
    * */
    executeFunctions (button, type) {
      if (button.jsActions) {
        let actions = JSON.parse(button.jsActions)
        actions && actions.length && actions.forEach(async action => {
          if (action.type === type) {
            await this.redcatApp[action.function](this)
          }
        })
      }
    },
    // 暂存表单
    async holdForm () {
      try {
        // 处理数据, 将表格中的空行去去掉
        await this.$axios.post(`/form-api/runtime/tempSave/${this.definition.id}`, this.dataService.data).then(res => {
          this.$message.success('暂存成功！')
          this.$emit('closeDialog', 'comfirm')
        })
      } finally {
        this.loading = false
      }
    },
    // 加载缓存数据
    loadHoldData (id) {
      return new Promise(async resolve => {
        // 加载缓存数据不应该影响表单的正常加载
        this.$axios.get(`/form-api/runtime/tempSave/${id}`).then(res => {
          if (res.data && Object.keys(res.data).length > 0) {
            this.dataService.data = this.dataService.buildModel(this.definition.form.archive.tableId, res.data, 'create')
            resolve(true)
          } else {
            resolve(false)
          }
        }).catch(() => resolve(false))
      })
    },
    // 顺序找到所有分组控件
    getGroupComponent (arr, groupArray = []) {
      arr.forEach(e => {
        if (e.componentType && e.componentType === 'rc-group' && e.properties && !e.properties.hidden && !e.properties.NIHidden) {
          groupArray.push(e)
        }
        if (e.children && e.children.length > 0) {
          this.getGroupComponent(e.children, groupArray)
        }
      })
      return groupArray
    },
    getGroupNav () {
      // 开启了分组导航并且有分组控件才会展示
      if (this.definition.form && this.definition.form.properties && this.definition.form.properties.groupNav && this.groupComponent.length > 0) {
        this.showGroupNav = true
      } else {
        this.showGroupNav = false
      }
      this.initStateObj.showGroupNav = this.showGroupNav
    },
    getDisscussOrLogDrawer () {
      if (this.definition.form && this.definition.form.properties && (this.definition.form.properties.enableLog || this.definition.form.properties.enableDiscuss)) {
        this.hasDiscussOrLogPane = true
        this.showDiscussOrLogTabPane = true
      }
    },
    showTabPane (show) {
      this.showDiscussOrLogTabPane = show
    },
    // 导航到分组
    navToGroup (tabpane) {
      let currentGroupComponent = this.groupComponent[tabpane.index]
      let currentGroupInstance = this.findVueByComponentId(currentGroupComponent.id)
      // 之前选中的分组控件取消高亮
      if (this.oldGroupComponent && currentGroupInstance && this.oldGroupComponent.component.id !== currentGroupInstance.component.id) {
        this.oldGroupComponent.remind = false
      }
      this.oldGroupComponent = currentGroupInstance
      if (currentGroupInstance) {
        // 高亮并展开当前导航到的分组
        currentGroupInstance.remind = true
        currentGroupInstance.fold = false
        this.$nextTick(() => {
          this.$refs.formMain.$el.scrollTo(0, currentGroupInstance.$el.offsetTop - 40)
        })
      }
    },
    // 定制这边如果 beforeValidate 校验失败需要默认聚焦到第一个控件
    focusErrorInput () {
      this.$nextTick(() => {
        if (this.$refs.formMain && this.$refs.formMain.$el) {
          let isError = this.$refs.formMain.$el.querySelectorAll('.is-error')
          if (isError && isError.length !== 0) {
            // 表格内部不知道什么时候校验表单，所以这里加了个eventBus，用来控制表单必填样式
            this.eventBus.$emit('form.afterValidate')
            if (isError[0].querySelector('input')) {
              isError[0].querySelector('input').focus()
            } else if (isError[0].querySelector('textarea')) {
              isError[0].querySelector('textarea').focus()
            }
          }
        }
      })
    }
  },
  computed: {
    showHint () {
      if (this.dataService && this.dataService.data && (this.dataService.data.dataState !== 'update' && this.dataService.data.dataState !== undefined)) {
        if (this.isShow) return true
        if (this.definition.form && this.definition.form.properties && this.definition.form.properties.continueCreate) {
          return true
        }
      } else {
        return false
      }
    },
    getShowButton () {
      return button => {
        let show
        if (button.type === 'hold') {
          // 只有新建有暂存按钮
          show = this.dataService && this.dataService.data && this.dataService.data.dataState === 'create'
        } else {
          show = !button.hidden
        }
        return show
      }
    },
    groupComponent () {
      return this.getGroupComponent(this.definition.form.children)
    }
  },
  watch: {
    'definition.form.properties.continueCreate' (val) {
      if (this.isShow === false && val === true) {
        this.isShow = true
      }
    }
  },
  inject: ['currentMenu']
}
</script>

<style lang="scss">
  .form-runtime {
    background: #fff;
    box-shadow: 4px 4px 4px rgba(174, 222, 251, 0.1);
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
    position: relative;
    ::-webkit-input-placeholder { /* WebKit browsers */
      color: #232323;
    }
    :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
      color: #232323;
    }
    ::-moz-placeholder { /* Mozilla Firefox 19+ */
      color: #232323;
    }
    :-ms-input-placeholder { /* Internet Explorer 10+ */
      color: #232323;
    }
    &, .el-main {
      height: 100%;
      .el-form-item__content {
        height: 100%;
        font-size: 12px;
      }
    }
    main.el-main{
      padding: 20px;
      position: relative;
      /* 开启日志或讨论的时候右侧空出固定宽度330px */
      &.form-runtime-main-padding{
        padding-right: 330px;
      }
      .form-group-nav{
        width: 124px;
        height: calc(100% - 200px);
        position: fixed;
        overflow-y: scroll;
        .el-tabs__header.is-left{
          width: 114px;
          .el-tabs__item{
            display: flex;
            align-items: center;
            height: 50px;
            padding-left: 0;
            padding-right: 10px;
            span{
              display: inline-block;
              width: 100%;
              height: 28px;
              line-height: 14px;
              overflow: hidden;
              text-align: right;
              white-space: pre-line;
              text-overflow: ellipsis;
            }
          }
        }
        .el-tabs__content{
          display: none;
        }
        @media (min-width: 1366px){
          width: 134px;
          .el-tabs__header.is-left{
            width: 124px;
          }
        }
      }
    }
    .el-footer {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      .runtime-buttons{

        >button{
          position: relative;
          .el-icon-loading {
            position: absolute;
            right: 0;
            top: 7px;
          }
          &:focus{
            border-color: #2355a7;
          }
        }
      }
    }
    .form-footer {
      position: relative;
      &.form-runtime-footer-padding{
        margin-right: 330px;
      }
      .continue-create {
        height: 20px;
        position: absolute;
        left: 32px;
        top: 23px;
        .is-checked {
          .el-checkbox__label {
            color: #606266;
          }
          .el-checkbox__inner {
            &::after {
              display: none;
            }
            width: 14px;
            height: 16px;
            display: inline-block;
            background: url('../componentAttr/assets/select.png') no-repeat;
            background-size: 14px;
            border: none;
          }
        }
        .is-focus {
          .el-checkbox__inner {
            border-color: #DCDFE6;
          }
        }
      }
    }
    .el-input.is-disabled .el-input__inner {
      background: #F2F3F5;;
      border:1px solid #c2c3c4;
    }
    .rc-container .container-form {
      .rc-rich {
        height: 100%;
        .el-form-item {
          height: 100%;
        }
        .el-form-item__content {
          height: 100%;
        }
      }
    }
  }
  .el-message.el-message--info.is-center.without-execute-dialog{
    position: fixed;
    left: calc(50% + 100px);
    top: 40%;
    background-color: #29282E;
    >p{
      color: #FFFFFF;
    }
    >i{
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/runtime/form-runtime.vue